import React, { PropsWithChildren, useState } from "react";
import sass from "../desc.module.sass";
import cn from "classnames";

interface IAccordionItem extends PropsWithChildren {
	title: string;
	plusHandler?: (e: React.MouseEvent<HTMLDivElement>) => void;
}
const AccordionItem: React.FC<IAccordionItem> = ({ children, title, plusHandler }) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<div
			onClick={() => {
				setIsOpen((prevState) => !prevState);
			}}
			className={cn(sass.accordion__item, sass[`accordion__item-${isOpen ? "open" : "close"}`])}>
			<div className={sass["accordion__item-title"]}>
				{title}
				<div className={sass["icon-wrapper"]}>
					{plusHandler && (
						<div onClick={plusHandler} className={sass["accordion__item-icon"]}>
							<div className={sass.plus} />
						</div>
					)}
					<div className={sass["accordion__item-icon"]}>
						<div className={sass.arrow} />
					</div>
				</div>
			</div>
			<div className={sass["accordion__item-content"]}>{children}</div>
		</div>
	);
};

export default AccordionItem;
